export const EVENT_TYPE = {
    AM_TRAINING: 'AM練習',
    PM_TRAINING: 'PM練習',
    OFFICIAL_GAME: '公式戦',
    PRACTICE_GAME: '練習試合'
} as const;

export type EventType = typeof EVENT_TYPE[keyof typeof EVENT_TYPE];
